<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vi5yhW/tc-custom/9781683830474.jpg?1705766123532" alt="This image is the cover for the book Mafia III: Plain of Jars, Mafia III"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mafia III: Plain of Jars, Mafia III
      </h1>
      <p class="bookDescription body article font2">
        <b>A mobster’s adopted son sees action in the Vietnam War and as a CIA operative in this pulp-fiction-inspired prequel to the hit video game.</b><br/><br/>Before Lincoln Clay laid waste to New Bordeaux in his quest for vengeance against the Italian mob, he did an equally action-packed tour of Vietnam. In this authorized prequel to the hit game <i>Mafia III</i>, Clay learns the skills he will use back in New Bordeaux—first as an Army grunt, then as a Special Forces soldier running covert ops for the CIA.<br/><br/>Featuring characters and locations from the game and a brand-new, original storyline full of intrigue, passion, and suspense, <i>Mafia III: Plain of Jars</i> is a great read for fans of the game and crime genre hounds looking for more of the Mafia world to explore.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Mariotte, Marsheila Rockwell
      </h2>
      
      <p class="authorDescription body article">Marsheila (Marcy) Rockwell was born an indeterminate number of years ago in America’s Last, Best Place. Perhaps that explains her early penchant for fantasy and horror – the first book she ever read (at the tender age of three) was Frank L. Baum’s Ozma of Oz. Marcy now lives in the desert in the shadow of an improbably green mountain where she writes dark fiction and poetry, often with her writing partner and husband, Jeffrey J. Mariotte.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Insight Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18b04f2d